import React, {useState, useEffect} from 'react'
import List from "../../Components/List"
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import getGenresByOffset from "../../GraphQL/queries/getGenresByOffset";
import getNumberOfGenres from "../../GraphQL/queries/getNumberOfGenres"
import { generateHeaders } from "../../Services/Users"
import { Headers } from '../../constants/headers'
import { useHistory } from "react-router-dom"
import { Button, Modal, Form, Input } from 'antd';
import Loading from "../../Components/Loading"
import GetGenre from "../../GraphQL/queries/getGenre"
import UpdateGenre from "../../GraphQL/mutations/updateGenre"
import { SaveGenreService, UpdateGenreService } from "../../Services"
import SaveGenre from "../../GraphQL/mutations/saveGenre"
import RemoveGenre from "../../GraphQL/mutations/removeGenre"

const validateMessages = {
    required: '${label} is required!',
};

export default () => {
    const headers = Headers["Genre"]
    const history = useHistory()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
    const [genre, setGenre] = useState(null)
    const [mode, setMode] = useState(null)
    const [genreValue, setGenreValue] = useState("")
    const [genreId, setGenreId] = useState(null)
    const [getGenre, { data: dataLazy }] = useLazyQuery(GetGenre, {
        onCompleted() {
            console.log(dataLazy.Genre.Genero)
            setGenre(dataLazy.Genre)
            setGenreValue(dataLazy.Genre.Genero)
        },
        fetchPolicy: "network-only"
    })
    const [createGenre] = useMutation(SaveGenre, {
        onCompleted(){
            refetch()
        }
    })
    const [genres, setGenres] = useState([])
    const [total, setTotal] = useState(0)
    const [offset, setOffset] = useState(1)
    const [dataLoad, setDataLoad] = useState(false)
    const { loading, error, data, refetch} = useQuery(getGenresByOffset, {variables: {admin: "true", offset: parseInt(offset) -1}, fetchPolicy: "network-only"})
    const { loading: loadingNumber, error: errorNumber, data: dataNumber} = useQuery(getNumberOfGenres, {fetchPolicy: "network-only"})
    const [updateGenre] = useMutation(UpdateGenre, {
        onCompleted() {
            refetch()
        }
    })
    const [removeGenre] = useMutation(RemoveGenre, {
        onCompleted() {
            refetch()
        }
    })

    const handleChangeGenre = (event) => {
        setGenreValue(event.target.value)
    };

    const handleOk = () => {
        UpdateGenreService(genre.IdGenero, genreValue, updateGenre)
        setGenre(null)
        setMode(null)
        setGenreValue("")
        setIsModalVisible(false);
    };

    const handleSave = () => {
        SaveGenreService(genreValue, createGenre)
        setGenre(null)
        setMode(null)
        setGenreValue("")
        setIsModalVisible(false)
    }

    const handleCancel = () => {
        setGenre(null)
        setMode(null)
        setGenreValue("")
        setIsModalVisible(false);
    };

    const removeElement = (id) => {
        setGenreId(id)
        setIsModalDeleteVisible(true)
    }

    const editElement = (id) => {
        getGenre({ variables: { IdGenero: id } })
        setMode(2)
    }

    useEffect(() => {
        if (genre) {
            setIsModalVisible(true);
        }
    }, [genre])

    const createElement = () => {
        setGenre([])
        setMode(1)
    }

    const updateTable = (total, range) => {
        if (range[0] !== offset) {
            setOffset(range[0])
        } else {
            setDataLoad(true)
        }
    }

    const handleDeleteCancel = () => {
        setIsModalDeleteVisible(false)
    }

    const handleRemove = () => {
        removeGenre({ variables: { ID: genreId } })
        setGenreId(null)
        setIsModalDeleteVisible(false)
    }

    const handleChange = () => {
    }

    const headerColumns = generateHeaders(headers, editElement, removeElement)

    useEffect(() => {
        if (!loading && !error && data) {
            setGenres(data.GenreLimit)
        }
    }, [loading, data,error])

    useEffect(() => {
        if (!loadingNumber && !errorNumber && dataNumber) {
            setTotal(dataNumber.genres)
        }
    }, [loadingNumber, dataNumber, errorNumber])

    useEffect(() => {
        if(dataLoad && offset) {
            refetch()
        }
    }, [offset, dataLoad ,refetch])

    if (error || errorNumber) return <span>Componente de error</span>
    if ((loading || loadingNumber) && !dataLoad) return <Loading />
    

    return (
        <>
            <Button onClick={createElement} style={{marginBottom: "10px", marginLeft: "10px"}} type="primary" htmlType="submit">
                Add Genre
            </Button>
            {console.log(data)}
            <List dataTable={genres} total={total} updateTable={updateTable} loading={loading} headerColumns={headerColumns} handleChange={handleChange}/>
            <Modal title={mode === 2 ? "Edit Genre" : "New Genre"} visible={isModalVisible} onOk={mode === 2 ? handleOk : handleSave} onCancel={handleCancel} okText={mode === 2 ? "Edit" : "Save"}>
                {genre && (
                    <Form name="nest-messages" validateMessages={validateMessages}>
                        <Form.Item label="Name" rules={[{ required: true }]}>
                            <Input onChange={handleChangeGenre} defaultValue={genreValue} className="inputStyle"/>
                        </Form.Item>
                    </Form>
                )}
            </Modal>
            <Modal title="Delete Genre" visible={isModalDeleteVisible} onOk={handleRemove} onCancel={handleDeleteCancel} okText="Remove">
                <p>Are you sure you want to delete?</p>
            </Modal>
            <br></br>
            <br></br>
        </>
    )
    
}